import type { Options } from "@sentry/core";
import { init, setTags } from "@sentry/nextjs";
import type { BrowserOptions } from "@sentry/react";
import { getChannel } from "@website/utils/channel/get-channel";
import { Channels } from "@website/utils/channel/types";

const ignoredErrors = [
  "getParams",
  "ym",
  "yandex",
  "gtm",
  "webengage",
  "goalParams",
  "ym is not defined",
  "Object captured as promise rejection with keys",
  "Load failed",
  "Failed to fetch",
  "net::ERR",
  "NetworkError",
  "snapp token conversion failed"
];

export const initBugTracking = (
  configs: BrowserOptions | Options,
  ignorePatterns: Array<RegExp> = []
) => {
  setTags({
    appName: process.env.NEXT_PUBLIC_APP_NAME,
    appChannel: getChannel() as Channels,
    appVersion: process.env.NEXT_PUBLIC_IMAGE_VERSION
  });
  return init({
    ...configs,
    enabled: process.env.NEXT_PUBLIC_BUILD_ENV === "production",
    environment: process.env.NEXT_PUBLIC_BUILD_ENV,
    release: process.env.NEXT_PUBLIC_IMAGE_VERSION,
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
    tracesSampleRate: configs?.tracesSampleRate ?? 0.1,
    integrations: configs?.integrations,
    beforeSend: (event) => {
      const exceptionValue = event?.exception?.values?.[0]?.value || "";

      const shouldIgnore = ignorePatterns.some((regex) =>
        regex.test(exceptionValue)
      );
      if (shouldIgnore) {
        return null;
      }
      for (const exception of event?.exception?.values ?? []) {
        if (
          ignoredErrors.some((error) => exception?.value?.includes?.(error))
        ) {
          return null;
        }
      }
      return event;
    }
  });
};
